export const validUser =  new RegExp('[A-Z0-9]{10}');
export const validPassword = new RegExp('^.{14,15}$');